import { render, staticRenderFns } from "./Management.vue?vue&type=template&id=456dcdd8&scoped=true&"
import script from "./Management.vue?vue&type=script&lang=js&"
export * from "./Management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456dcdd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('456dcdd8')) {
      api.createRecord('456dcdd8', component.options)
    } else {
      api.reload('456dcdd8', component.options)
    }
    module.hot.accept("./Management.vue?vue&type=template&id=456dcdd8&scoped=true&", function () {
      api.rerender('456dcdd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/reporting/Management.vue"
export default component.exports